var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifyOverlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 800,
    viewBox: "0 0 360 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M0 0H360V800H0V0Z",
    fill: "url(#paint0_linear_1298_2257)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1298_2257",
    x1: 180,
    y1: 0,
    x2: 180,
    y2: 800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0667FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00751407,
    stopColor: "#0667FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291793,
    stopColor: "#0767FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06368,
    stopColor: "#0768FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109701,
    stopColor: "#0869FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165926,
    stopColor: "#096CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23104,
    stopColor: "#0B70FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303727,
    stopColor: "#0E75FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382673,
    stopColor: "#127CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46656,
    stopColor: "#1785F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554074,
    stopColor: "#1D90F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643899,
    stopColor: "#259EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73472,
    stopColor: "#2EAFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825221,
    stopColor: "#39C2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914086,
    stopColor: "#46D9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54F3E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyOverlay);
export default __webpack_public_path__ + "static/media/notify_overlay.c590daa81d31a7bc3852a3c7d70c49d2.svg";
export { ForwardRef as ReactComponent };